import React from 'react';
import styled from 'styled-components';
import IconInfoSvg from '@catalogo/ui-americanas-desktop-svg/icon-info.svg';
import { AlertProps } from '../help/interfaces';

export const Alert: React.FC<AlertProps> = ({ showAlert }) => {
  if (!showAlert) {
    return null;
  }

  return (
    <Component>
      <IconInfoUI />
      <p>
        <b>Produto reembalado:</b> Este produto pode ter danos na embalagem ou ter sido aberto e devolvido, mas nunca
        foi usado e, por isso, tem a mesma garantia de um produto novo.&nbsp;
        <a href="#modal-rewrapped-product">saiba mais</a>
      </p>
    </Component>
  );
};

const Component = styled.div`
  height: 88px;
  padding: 16px;
  display: flex;
  font-size: 12px;
  font-weight: 700;
  max-width: 408px;
  border-radius: 8px;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.grey.darker};
  background-color: ${({ theme }) => theme.info.light};

  a {
    text-decoration: underline;
  }

  @media (min-width: 700px) {
    margin-bottom: 0px;
  }
`;

const IconInfoUI = styled(IconInfoSvg)`
  width: 56px;
  height: 56px;
  margin-right: 16px;
`;

export default Alert;
